import { useState } from "react";
import './balance.css';
import axios from "axios";

export function Balance() {
    const [bal, setBal] = useState(0);
    const onBalance = (e) => {
        e.preventDefault();
        const acId = e.target.acId.value;
        console.log(`Id ${acId} `);

        axios(`https://www.tigerbank.store/balance/${acId}`)
        .then(json => {
            console.log(json.bal); // 추가한 부분
            setBal(parseInt(json.bal.replace(/,/g, ''), 10).toLocaleString('en-US'));
        })
        .catch(error=>{
            console.error('데이터 요청이 실패하였습니다.',error)
        })
    }

    return (
        <div className="balCont">
            <div className="p--section">
                <h1> 현재자산 <span className="point">{bal}</span></h1>
                <form onSubmit={onBalance}>
                    <input type='number' placeholder='계좌 번호' name='acId'/>
                    <input type='submit' value='잔액' />
                </form>
            </div>
        </div>
    );
}

export default Balance;
